import anime from 'animejs';
import Swiper from 'swiper';

export default class {
    constructor() {
        this.mask = document.querySelector('#js-loading__mask')
        this.first = "#js-loading__mask .js-loading__first"
        this.second = "#js-loading__mask .js-loading__second"
        this.logoAnimation_elm = document.querySelector('#logo-animation')
        if (this.mask) {
            this.mask.style.display = "block"
        }

        if (process.env.MIX_DISP_LOADING == "false" && process.env.NODE_ENV == "development") {
            if (this.mask) {
                this.mask.style.display = "none"
            }
        }

        this.setupLinkClickListener();
    }

    setupLinkClickListener() {
        document.querySelectorAll('a[data-barba-prevent="all"]').forEach(link => {
            link.addEventListener('click', (event) => {
                sessionStorage.setItem('isBarbaNavigation', 'true');
            });
        });
    }

    beforeOnce(data) {
        const self = this;
        return new Promise(resolve => {
            let timeline = anime.timeline();

            // timeline
            // .add({
            //     targets: '#logo-animation',
            //     opacity: [0, 1],
            //     easing: 'easeOutExpo',
            //     duration: 400
            // })
            // .add({
            //     targets: '#logo__mark',
            //     opacity: [0, 1],
            //     translateY: ["-30px", 0],
            //     rotateY: [0, "720deg"],
            //     easing: 'easeOutQuint',
            //     duration: 1600
            // })
            // .add({
            //     targets: '#logo__str',
            //     opacity: [0, 1],
            //     translateY: ["10px", 0],
            //     easing: 'easeInOutQuart',
            //     duration: 600,
            //     complete: () => {
            //         this.loadingSetup()
            //         resolve();
            //     }
            // }, 1000)
            this.loadingSetup()
            resolve();
        })
    }

    once(data) {
        return new Promise(resolve => {
            resolve();
        })
    }

    afterOnce(data) {
        return new Promise(resolve => {
            const timelime = anime.timeline()
            timelime
                .add({
                    targets: this.first,
                    translateY: [0, "-120%"],
                    easing: 'easeOutCubic',
                    duration: 600
                }, 200)
                .add({
                    targets: this.second,
                    translateY: [0, "-120%"],
                    easing: 'easeInCubic',
                    duration: 600,
                    complete: () => {
                        this.mask = document.querySelector('#js-loading__mask')
                        this.mask.style.display = "none"

                        this.loadingAnimation()
                        this.heroSlider()
                        resolve();
                    }
                }, '-=400')
                // .add({
                //     targets: this.logoAnimation_elm,
                //     translateY: [0, "-100%"],
                //     opacity: [1, 0],
                //     easing: 'easeInExpo',
                //     duration: 1000,
                //     complete: () => {
                //         this.mask = document.querySelector('#js-loading__mask')
                //         this.mask.style.display = "none"

                //         this.loadingAnimation()
                //         this.heroSlider()
                //         resolve();
                //     }
                // }, 600)
        });
    }

    beforeLeave(data) {
        return new Promise(resolve => {
            resolve();
        })
    }

    leave(data) {
        return new Promise(resolve => {
            this.mask = document.querySelector('#js-loading__mask')
            this.mask.style.display = "block"

            data.next.container.style.opacity = 0;
            const timelime = anime.timeline()
            timelime

                .add({
                    targets: this.first,
                    translateY: ["100%", 0],
                    easing: 'easeInCubic',
                    duration: 600,
                    complete: () => {
                        resolve();
                    }
                })

        });
    }

    afterLeave(data) {
        return new Promise(resolve => {
            resolve();
        })
    }

    beforeEnter(data) {
        return new Promise(resolve => {
            resolve();
        })
    }

    enter(data) {
        return new Promise(resolve => {
            resolve();
        })
    }

    afterEnter(data) {
        return new Promise(resolve => {
            resolve();
        })
    }

    after(data) {
        return new Promise(resolve => {
            const timelime = anime.timeline()
            timelime
                .add({
                    targets: this.first,
                    translateY: [0, "-120%"],
                    easing: 'easeOutCubic',
                    duration: 700,
                    begin: () => {
                        this.initialScroll()
                        this.loadingSetup()
                        data.next.container.style.opacity = 1;
                    }
                }, 600)
                .add({
                    targets: this.second,
                    translateY: [0, "-120%"],
                    easing: 'easeInCubic',
                    duration: 700,
                    complete: () => {
                        this.mask = document.querySelector('#js-loading__mask')
                        this.mask.style.display = "none"

                        this.loadingAnimation()
                        this.heroSlider()

                        resolve();
                    }
                }, '-=400')

        });
    }

    initialScroll() {
        if (location.hash == "") {
            window.scrollTo(0, 0);
        } else {
            let digit = location.hash.replace(/^#/, "");
            let anchor = document.getElementById(digit);
            if (!anchor) return;

            if (anchor) {
                const rect = anchor.getBoundingClientRect();
                const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                let top = rect.top + scrollTop;
                window.scrollTo(0, top);
            }

        }
    }

    loadingSetup() {
        const heroCatch = document.querySelector(".p-index__hero--catch-en")
        if (heroCatch) {
            let heroPrimary = document.querySelectorAll('.p-index__hero--catch-en-ln')
            if (heroPrimary.length > 0) {
                heroPrimary.forEach((h, i) => {
                    let pr_str = h.textContent.split("");
                    let str = "";
                    pr_str.map(s => {
                        str += "<span class='hero__str'>" + s + "</span>";
                    })

                    h.innerHTML = str;
                })
            }

            let heroSecondary = document.querySelector('.p-index__hero--catch-ja')
            if (heroSecondary) {
                let sc_str = heroSecondary.textContent.split("");
                let str = "";
                sc_str.map(s => {
                    str += "<span class='hero__str'>" + s + "</span>";
                })

                heroSecondary.innerHTML = str;
            }
        }
    }

    loadingAnimation() {
        const heroCatch = document.querySelector(".p-index__hero--catch-en")
        if (heroCatch) {
            let str_animation = anime.timeline();
            str_animation.add({
                targets: '.p-index__hero--catch-en .hero__str',
                translateY: ["100%", 0],
                easing: "easeOutExpo",
                delay: function (el, i) {
                    return (i * 30);
                },
                duration: 2000
            })
        }

    }

    heroSlider() {
        const hero = document.querySelector('#js-hero__slider')
        if (hero) {
            const movie = document.querySelector('#kv-movie')
            movie.pause()
            const swiper = new Swiper('#js-hero__slider', {
                loop: true,
                effect: 'fade',
                speed: 2000,
                allowTouchMove: false,
                simulateTouch: false,
                autoplay: {
                    delay: 1200
                }
            })
            swiper.on('slideChangeTransitionStart', function () {
                const video = document.querySelector('.swiper-slide-active .kv')
                if (video) {
                    movie.pause()
                    movie.currentTime = 0
                    movie.play()
                }
            });
        }
    }
}





// import anime from 'animejs';
// import Swiper from 'swiper';

// export default class{
//     /**
//      * loading要素の初期設定等を行うコンストラクタ
//      * DOM生成時に即時実行
//      */
//     constructor() {
//         this.mask = document.querySelector('#js-loading__mask')
//         this.first = "#js-loading__mask .js-loading__first"
//         this.second = "#js-loading__mask .js-loading__second"
//         this.logoAnimation_elm = document.querySelector('#logo-animation')
//         if(this.mask){
//             this.mask.style.display = "block"
//         }

//         if(process.env.MIX_DISP_LOADING == "false" && process.env.NODE_ENV == "development"){
//             if(this.mask){
//                 this.mask.style.display = "none" 
//             }
//         }
//     }
//     /**
//      * 初期表示前に1度だけ実行
//      * @param {*} data 
//      */
//     beforeOnce(data){
//         const self = this;
//         return new Promise(resolve => {

//             let timeline = anime.timeline();

//             timeline
//             .add({
//                 targets: '#logo-animation',
//                 opacity:[0,1],
//                 easing: 'easeOutExpo',
//                 duration : 400
//             })
//             .add({
//                 targets: '#logo__mark',
//                 opacity:[0,1],
//                 translateY:["-30px",0],
//                 rotateY:[0,"720deg"],
//                 easing: 'easeOutQuint',
//                 duration :1600
//             })
//             .add({
//                 targets: '#logo__str',
//                 opacity:[0,1],
//                 translateY:["10px",0],
//                 easing: 'easeInOutQuart',
//                 duration : 600,
//                 complete: () =>{
//                     this.loadingSetup()
//                     resolve();
//                 }
//             // 初期読み込み時の待ち時間
//             },1000)
//         })
//     }
//     /**
//      * 初期表示時に1度だけ実行
//      * @param {*} data 
//      */
//     once(data){
//         return new Promise(resolve => {
//             resolve();
//         })
//     }
//     /**
//      * 初期表示完了後に1度だけ実行
//      * @param {*} data 
//      */
//     afterOnce(data){

//         return new Promise(resolve => {
//             const timelime = anime.timeline()
//             timelime
//             .add({
//                 targets: this.first ,
//                 translateY : [0,"-120%"],
//                 easing: 'easeOutCubic',
//                 duration : 600
//             },200)
//             .add({
//                 targets: this.second,
//                 translateY : [0,"-120%"],
//                 easing: 'easeInCubic',
//                 duration : 600
//             },'-=400')
//             .add({
//                 targets: this.logoAnimation_elm,
//                 translateY: [ 0 ,"-100%"],
//                 opacity: [1,0],
//                 easing: 'easeInExpo',
//                 duration : 1000,
//                 complete: () =>{
//                     this.mask = document.querySelector('#js-loading__mask')
//                     this.mask.style.display = "none"

//                     this.loadingAnimation()
//                     this.heroSlider()
//                     resolve();
//                 }
//             // 初期読み込み時の待ち時間
//             },600)
//         });
//     }
//     /**
//      * 次ページ読み込み前に実行
//      * @param {*} data 
//      */
//     beforeLeave(data){
//         return new Promise(resolve => {
//             resolve();
//         })
//     }
//     /**
//      * 次ページ読み込み時に実行
//      * @param {*} data 
//      */
//     leave(data){

//         return new Promise(resolve => {
//             this.mask = document.querySelector('#js-loading__mask')
//             this.mask.style.display = "block"
            
//             data.next.container.style.opacity = 0;
//             const timelime = anime.timeline()
//             timelime
            
//             .add({
//                 targets: this.first,
//                 translateY : ["100%",0],
//                 easing: 'easeInCubic',
//                 duration : 600,
//                 complete : () => {
//                     resolve();
//                 }
//             })

//         });
//     }
//     /**
//      * 次ページ読み込み完了後に実行
//      * @param {*} data 
//      */
//     afterLeave(data){
//         return new Promise(resolve => {
//             resolve();
//         })
//     }
//     /**
//      * 次ページ表示前に実行
//      * @param {*} data 
//      */
//     beforeEnter(data){
//         return new Promise(resolve => {
//             resolve();
//         })
//     }
//     /**
//      * 次ページ表示時に実行
//      * @param {*} data 
//      */
//     enter(data){
//         return new Promise(resolve => {
//             resolve();
//         })
//     }
//     /**
//      * 次ページ表示完了後に実行
//      * @param {*} data 
//      */
//     afterEnter(data){
//         return new Promise(resolve => {
//             resolve();
//         })
//     }
//     /**
//      * すべて完了後に実行
//      * @param {*} data 
//      */
//     after(data){

//         return new Promise(resolve => {

//             const timelime = anime.timeline()
//             timelime
//             .add({
//                 targets: this.first ,
//                 translateY : [0,"-120%"],
//                 easing: 'easeOutCubic',
//                 duration : 700,
//                 begin: () => {
//                     this.initialScroll ()
//                     this.loadingSetup()
//                     data.next.container.style.opacity = 1;
//                 }
//             },600)
//             .add({
//                 targets: this.second,
//                 translateY : [0,"-120%"],
//                 easing: 'easeInCubic',
//                 duration : 700,
//                 complete : () => {
//                     this.mask = document.querySelector('#js-loading__mask')
//                     this.mask.style.display = "none"

//                     this.loadingAnimation()
//                     this.heroSlider()

//                     // setTimeout(() => { this.initialScroll () }, 2000)
//                     resolve();
//                 }
//             },'-=400')

            
//         });
//     }
//     initialScroll (){
//         if( location.hash == "" ){
//             window.scrollTo(0,0);
//         }else{
//             let digit = location.hash.replace(/^#/,"");
//             let anchor = document.getElementById( digit );
//             if ( !anchor ) return;
            
//             if(anchor){
//                 const rect = anchor.getBoundingClientRect();
//                 const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
//                 let top = rect.top + scrollTop;
//                 // const header = document.querySelector('[data-header]');
//                 // if(header){
//                 //     if(header){
//                 //         top = top - header.clientHeight;
//                 //     }
//                 // }
//                 window.scrollTo(0,top);
//             }
            
//         }
//     }
//     loadingSetup(){
//         const heroCatch = document.querySelector(".p-index__hero--catch-en")
//         if(heroCatch){
//             let heroPrimary = document.querySelectorAll('.p-index__hero--catch-en-ln')
//             if(heroPrimary.length > 0){
//                 heroPrimary.forEach( (h,i) => {
//                     let pr_str = h.textContent.split("");
//                     let str = "";
//                     pr_str.map( s => {
//                         str += "<span class='hero__str'>" + s  + "</span>";
//                     })
                        
//                     h.innerHTML = str;
//                 })
//             }

//             let heroSecondary = document.querySelector('.p-index__hero--catch-ja')
//             if(heroSecondary){
//                 let sc_str = heroSecondary.textContent.split("");
//                 let str = "";
//                 sc_str.map( s => {
//                     str += "<span class='hero__str'>" + s  + "</span>";
//                 })
                    
//                 heroSecondary.innerHTML = str;
//             }
//         }
//     }
//     loadingAnimation(){
//         const heroCatch = document.querySelector(".p-index__hero--catch-en")
//         if(heroCatch){
//             // setTimeout(function(){
//             let str_animation =  anime.timeline();
//             str_animation.add({
//                 targets : '.p-index__hero--catch-en .hero__str',
//                 translateY: ["100%",0],
//                 easing: "easeOutExpo",
//                 delay: function(el, i) {
//                     return (i * 30);
//                 },
//                 duration:2000
//             })
//         }

//     }
//     heroSlider(){
//         const hero = document.querySelector('#js-hero__slider')
//         if(hero){
//             const movie = document.querySelector('#kv-movie')
//             movie.pause()
//             const swiper = new Swiper ('#js-hero__slider',{
//                 loop: true,
//                 effect :'fade',
//                 speed:2000,
//                 allowTouchMove :false,
//                 simulateTouch:false,
//                 autoplay: {
//                     delay: 1200
//                 }
//             })
//             swiper.on('slideChangeTransitionStart', function () {
//                 const video = document.querySelector('.swiper-slide-active .kv')
//                 if(video){
//                     movie.pause()
//                     movie.currentTime = 0
//                     movie.play()
//                 }
//             });
//         }
//     }
// }